import CustomerConfigPageComponent from './CustomerConfigPage';

export default CustomerConfigPageComponent;
